import React, { Component } from 'react';
import { Icon } from '../../components';
import Theme from '../../theme';
import Sizes from '../../sizes';
import { defaultScale } from '../../utils/scaling';

import {
  View,
  Text,
  Platform,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  TextInput as RNTextInput,
} from 'react-native';

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTextSecure: props.isSecure || false
    };
  }

  unbounceTimeout;
  async onChangeText(value: string) {
    const { debounce = false, input: { onChange } } = this.props;

    if (this.unbounceTimeout) {
      clearTimeout(this.unbounceTimeout);
    }

    if (debounce) {
      this.unbounceTimeout = setTimeout(async () => {
        await onChange(value);
      }, 500);
    } else {
      await onChange(value);
    }
  }

  toggleIsSecure = () => {
    this.setState({
      isTextSecure: !this.state.isTextSecure
    });
  }

  focus = () => {
    if (this.input) this.input.focus();
  }

  blur = () => {
    if (this.input) this.input.blur();
  }

  onBlur = () => {
    const { input: { onChange, value }, trim } = this.props;
    const trimmedValue = trim ? value.trim() : value;
    onChange(trimmedValue);
  }

  shouldShowLabel = () => {
    const { input: { value }, showLabel = true } = this.props;

    if (Platform.OS == 'web' && isMobile == false && showLabel) {
      return true;
    } else {
      return !!value && showLabel;
    }
  }

  render() {
    const {
      input: { onChange, value, ...restInput },
      meta: { touched, error } = {},
      onEnter,
      isInlineValidation= true,
      multiline,
      children,
      defaultValue,
      editable = true,
      placeholder,
      icon,
      label,
      showLabel = true,
      isRequired = true,
      numberOfLines = 1,
      labelStyle,
      inputContainerStyle,
      errorTextStyle,
      inputHeight = null,
      textInputStyle,
      iconStyle,
      placeHolderTextStyle = null,
      placeHolderMargin,
      unitSuffixText,
      autoFocus = false,
      autoCapitalize='none',
      mainContainerStyle,
      ...restProps
    } = this.props;
    const { isTextSecure } = this.state;
    const showError = (value.length > 0 && !!error) || (touched && !!error);
    const height = inputHeight ? inputHeight : numberOfLines * Sizes.InputHeight;

    const appliedInputStyle = multiline
      ? styles.inputTextAlignTop
      : styles.inputTextAlignCenter;

    const appliedTextInfo = multiline
      ? styles.textInfoContainerMultiLine
      : styles.textInfoContainerSingleLine;

    let fieldTitle = placeholder;
    if (label) {
      fieldTitle = label;
    }

    return (
      <View style={[styles.container, mainContainerStyle]}>
        {this.shouldShowLabel() &&
          <Text style={[styles.labelText, labelStyle]}>{fieldTitle}</Text>
        }
        <View style={{flexDirection: 'row'}}>
        <View style={[styles.inputContainer, inputContainerStyle,
           touched && !!error && styles.containerError, {width: unitSuffixText ? '80%' : '100%'}]}>
          <RNTextInput
            ref={(ref) => { this.input = ref; }}
            multiline={multiline}
            defaultValue={value}
            disableFullscreenUI={true}
            autoFocus={autoFocus}
            autoCapitalize={autoCapitalize}
            allowFontScaling={false}
            placeholder={placeholder}
            onSubmitEditing={onEnter}
            placeholderTextColor={placeHolderTextStyle ? placeHolderTextStyle : Theme.GREY_MEDIUM}
            onBlur={this.onBlur}
            editable={editable}
            secureTextEntry={isTextSecure}
              style={[styles.input, appliedInputStyle, { height: defaultScale(height) }, textInputStyle]}
            onChangeText={onChange}
            {...restInput}
            {...restProps}>
            {children}
          </RNTextInput>
          {showError && isInlineValidation &&
            <View style={appliedTextInfo}>
              <Text style={[styles.error, errorTextStyle]}>
                {error}
              </Text>
            </View>
          }
          {isRequired && !showError &&
            <View style={appliedTextInfo}>
              <Text style={[styles.requiredAsterisk, {
                color: placeHolderTextStyle ? placeHolderTextStyle : Theme.GREY_MEDIUM,
              }]}>
                *
              </Text>
            </View>
          }
          {icon &&
            <TouchableOpacity
              onPress={icon.onPress}
              disabled={icon.disabled}
              style={[styles.iconContainer, icon.disabled && styles.disabledIconContainer, iconStyle]}>
              <Icon
                size={30}
                name={icon.name}
                color={Theme.GREY_LIGHT}
              />
            </TouchableOpacity>
          }
        </View>
        {
          unitSuffixText &&
          <View style={[styles.inputContainer, inputContainerStyle,
          {width: '18%', marginLeft: '2%', alignItems: 'center'}]}>
          <Text style={[textInputStyle,
            styles.placeHolderInput, placeHolderMargin,
            {color: placeHolderTextStyle ? placeHolderTextStyle : Theme.GREY_MEDIUM}]}>{unitSuffixText}</Text>
          </View>
        }
        </View>
        {!isInlineValidation && showError && <View style={appliedTextInfo}>
              <Text style={[styles.error, errorTextStyle,{paddingHorizontal: 0}]}>
                {error}
              </Text>
        </View>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginVertical: defaultScale(5),
  },
  labelText: {
    ...Theme.textStyle.small,
    color: Theme.GREY,
  },
  inputContainer: {
    borderRadius: 3,
    flexDirection: 'row',
    backgroundColor: Theme.GREY_LIGHT,
  },
  containerError: {
    borderColor: Theme.RED,
  },
  input: {
    flex: 1,
    ...Theme.textStyle.bodyCopyReg,
    marginLeft: defaultScale(15),
    color: Theme.GREY_DARK,
    height: defaultScale(Sizes.InputHeight),
  },
  inputTextAlignTop: {
    textAlignVertical: 'top',
    ...Platform.select({
      web: {
        paddingTop: defaultScale(10),
      },
      ios: {
        paddingTop: defaultScale(10),
      },
      android: {
        paddingTop: defaultScale(10),
      }
    }),
  },
  inputTextAlignCenter: {
    textAlignVertical: 'center',
  },
  disabledIconContainer: {
    backgroundColor: Theme.GREY,
  },
  iconContainer: {
    paddingLeft: defaultScale(15),
    paddingRight: defaultScale(15),
    borderTopRightRadius: defaultScale(5),
    borderBottomRightRadius: defaultScale(5),
    justifyContent: 'center',
    backgroundColor: Theme.PRIMARY,
  },
  error: {
    ...Theme.textStyle.small,
    color: Theme.RED,
    paddingHorizontal: defaultScale(15),
  },
  requiredAsterisk: {
    paddingTop: defaultScale(5),
    paddingHorizontal: defaultScale(15),
    color: Theme.GREY_MEDIUM,
  },
  textInfoContainerSingleLine: {
    justifyContent: 'center',
  },
  textInfoContainerMultiLine: {
    paddingTop: defaultScale(10),
  },
  placeHolderInput: {
    ...Theme.textStyle.bodyCopyReg,
    marginLeft: defaultScale(15),
  },
});

export default TextInput;
